<template>
  <node-view-wrapper class="step-template-node" data-step-template>
    <div class="tools-right">
      <span @click="editHtml" class="tool">
        <img src="/images/icons/tiptap/codeview.svg" />
      </span>
      <span @click="saveAsStepTemplate" class="tool">
        <img src="/images/icons/tiptap/savedraft.svg" />
      </span>
    </div>
    <div class="step-template-content"
         ref="node"
         v-html="node.attrs.html"
         contenteditable="true"></div>
  </node-view-wrapper>
</template>

<script>
  import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2'
  import { EventBus } from '@/eventBus/eventBus.js';
  export default {
    name: 'FreeHtmlElementNode',
    components: {
      NodeViewWrapper,
    },
    mounted() {
      var id = (this.node.attrs["fh_id"])
      EventBus.$on(`update_freeHtml_${id}`, (value) => {
        this.updateAttributes({ html: value })
      });
    },
    props: nodeViewProps,
    methods: {
      editHtml(element) {
        var element = this.$refs.node.innerHTML
        EventBus.$emit('freeHtmlEditCalled', {element: element,id: this.node.attrs["fh_id"] })
      },

      saveAsStepTemplate(element) {
        var element = this.$refs.node
        EventBus.$emit('saveAsStepTemplate', element )
      },
    },
  }
</script>

<style scoped>
  .step-template-node {
    border: 1px dashed #888;
    padding: 1rem;
    margin: 0.5rem 0;
    border-radius: 0.5rem;
    position: relative;
    overflow: visible;
  }

  .step-template-content {
    position: relative;
    z-index: 1;
  }

  /* Position the tools absolutely in the top-right corner */
  .tools-right {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    gap: 6px;
    z-index: 2;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 6px;
    padding: 4px;
    box-shadow: 0 0 4px rgba(0,0,0,0.1);
  }

    /* Style the icons */
    .tools-right .tool img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      display: block;
      transition: transform 0.2s ease;
    }

      .tools-right .tool img:hover {
        transform: scale(1.1);
      }
</style>
